import Scene = Phaser.Scene;

export default class SceneUtils {

    private static currentScene: Scene | undefined;

    public static setCurrentScene(currentScene: Scene): void {
        SceneUtils.currentScene = currentScene;
    }

    public static tryGetCurrentScene(): Scene | undefined {
        return SceneUtils.currentScene;
    }

    /**
     * Returns current scene only if it looks usable for UI operations.
     * In some rare cases (startup / during scene transitions) currentScene may be unset
     * or no longer active, which leads to runtime errors like "reading 'add'".
     */
    public static tryGetActiveScene(): Scene | undefined {
        const scene = SceneUtils.currentScene;
        if (!scene) return undefined;
        try {
            // ScenePlugin API (Phaser): scene.scene.isActive()
            if (scene.scene && typeof scene.scene.isActive === 'function' && !scene.scene.isActive()) {
                return undefined;
            }
        } catch (e) {
            return undefined;
        }
        return scene;
    }

    public static getCurrentScene() {
        return SceneUtils.currentScene!;
    }

    public static tryGetCanvas(): HTMLCanvasElement | undefined {
        const scene = SceneUtils.currentScene;
        // @ts-ignore - Phaser internals vary slightly across builds
        return scene?.sys?.game?.canvas;
    }

    public static getCanvas() {
        return this.getCurrentScene().sys.game.canvas;
    }
}
